import React from 'react';

import MenuItemsDropdown from './MenuItemsDropdown';

class DefaultDropdown extends React.PureComponent {
  render() {
    return (
      <MenuItemsDropdown
        initialData={{ items: [] }}
        value={null}
        onChange={() => {}}
      />
    );
  }
}

export default DefaultDropdown;
